"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabContentMap;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _TabContentMapModule = _interopRequireDefault(require("./TabContentMap.module.scss"));

var _TabContentMap = _interopRequireDefault(require("./TabContentMap.i18n"));

var _assets = require("../../../../../../assets");

var _ColorizedImage = _interopRequireDefault(require("../../../../../common/ColorizedImage/ColorizedImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabContentMap(_ref) {
  var areaName = _ref.areaName,
      dominatingGuild = _ref.dominatingGuild,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentMapModule.default.content, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.areaLabel
  }, formatMessage(_TabContentMap.default.area)), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.areaValue
  }, areaName), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.guildLabel
  }, formatMessage(_TabContentMap.default.guild)), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.guildValue
  }, dominatingGuild === null || dominatingGuild === void 0 ? void 0 : dominatingGuild.name), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.guildMark,
    style: {
      backgroundColor: dominatingGuild === null || dominatingGuild === void 0 ? void 0 : dominatingGuild.cloakColor
    }
  }, dominatingGuild && /*#__PURE__*/_react.default.createElement(_ColorizedImage.default, {
    imgSrc: "".concat(_assets.ASSETS_GUILD_MARKS, "/").concat(dominatingGuild.iconFileName),
    color: dominatingGuild.iconColor
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.map
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.statusText1
  }, dominatingGuild && formatMessage(_TabContentMap.default.ownedBy, {
    guildName: dominatingGuild === null || dominatingGuild === void 0 ? void 0 : dominatingGuild.name
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.statusText2
  }, formatMessage(_TabContentMap.default.ableToChallenge)), /*#__PURE__*/_react.default.createElement("div", {
    className: _TabContentMapModule.default.statusText3
  }, formatMessage(_TabContentMap.default.waitingForChallengers)));
}